// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__u5vTG","rootMobile":"styles_rootMobile__2ShRI"};